import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { sortDimensiByTingkatan } from "./component/sortDimensiByTingkatan";
import { ClipLoader, PulseLoader } from "react-spinners";

const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;

    background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );

    background-size: 800px 104px;
  }

  .shimmer-select {
    height: 44px;
    border-radius: 12px;
  }

  .config-matrix-scroll {
    width: 100%;
    max-width: 100%;
    max-height: 570px;

    overflow-y: auto !important;
    overflow-x: hidden !important;

    -webkit-overflow-scrolling: touch;
  }

  .config-matrix-table {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;

    margin: 0 !important;

    table-layout: fixed !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .config-matrix-table thead th {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;

    padding: 12px 10px !important;

    background: #f3f5ff !important;
    color: #25345f !important;

    border-right: 1px solid #e1e6ef !important;
    border-bottom: 1px solid #dbe2ee !important;

    font-size: 13px !important;
    font-weight: 700 !important;
    line-height: 1.45 !important;

    text-align: center !important;
    vertical-align: middle !important;

    white-space: normal !important;
    overflow-wrap: break-word !important;
  }

  .config-matrix-table tbody td {
    padding: 12px 8px !important;

    background: #fff !important;
    color: #2b3654 !important;

    border-right: 1px solid #e6ebf3 !important;
    border-bottom: 1px solid #edf0f5 !important;

    font-size: 12.5px !important;

    text-align: center !important;
    vertical-align: middle !important;
  }

  .config-matrix-table thead th:last-child,
  .config-matrix-table tbody td:last-child {
    border-right: 0 !important;
  }

  .config-matrix-table tbody tr:hover td {
    background: #fafbff !important;
  }

  .config-matrix-toggle-wrap {
    min-height: 30px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .config-matrix-toggle-wrap .form-check {
    display: flex;
    align-items: center;
    justify-content: center;

    min-height: 0;

    margin: 0 !important;
    padding: 0 !important;
  }

  .config-matrix-toggle-wrap .form-check-input {
    margin: 0 !important;
    cursor: pointer;
  }

  @media (max-width: 780px) {
    .config-matrix-scroll {
      max-height: 520px;
    }

    .config-matrix-table thead th,
    .config-matrix-table tbody td {
      padding: 10px 5px !important;
      font-size: 10.5px !important;
    }
  }
`;

export default function PengaturanDimensiHead() {
  document.title = "Pengaturan Dimensi";

  const [savingMap, setSavingMap] = useState({});

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");

  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({
    query: "(max-width: 780px)",
  });

  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);

  const storageBranchGroping =
    localStorage.getItem("ysb_branch_id");

  const storageLevel =
    localStorage.getItem("level");

  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);

  const [getData, setGetData] = useState([]);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  const location = useLocation();
  const navigate = useNavigate();

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  useEffect(() => {
    const level = localStorage.getItem("level");

    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });

      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const isMounted = useRef(true);
  const abortControllers = useRef([]);
  const queryKeyRef = useRef("");

  useEffect(() => {
    return () => {
      isMounted.current = false;

      abortControllers.current.forEach((controller) =>
        controller.abort()
      );
    };
  }, []);

  const sortSchools = (schools = []) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((jenjang) =>
        String(a?.school_name || "")
          .toUpperCase()
          .includes(jenjang)
      );

      const jenjangB = order.findIndex((jenjang) =>
        String(b?.school_name || "")
          .toUpperCase()
          .includes(jenjang)
      );

      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") {
      return schools.filter(
        (school) =>
          school?.school_code !== "BASEMENT_BEKASI"
      );
    }

    return schools;
  };

  const filterKey = useMemo(() => {
    return [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_dimensi_id,
    ].join("|");
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
  ]);

  const groupedElements = useMemo(() => {
    const elements = getData?.[0]?.data_element || [];
    const groups = new Map();

    elements.forEach((element, index) => {
      const name =
        String(element?.name_element || "").trim() ||
        `Element ${index + 1}`;
      const key = name.toLowerCase();

      if (!groups.has(key)) {
        groups.set(key, {
          key,
          name,
          descriptions: [],
          elements: [],
        });
      }

      const group = groups.get(key);
      const description = String(
        element?.description || ""
      ).trim();

      if (
        description &&
        !group.descriptions.includes(description)
      ) {
        group.descriptions.push(description);
      }

      const isSameElement = group.elements.some(
        (item) => String(item?.id) === String(element?.id)
      );

      if (!isSameElement) {
        group.elements.push(element);
      }
    });

    return Array.from(groups.values()).map((group) => ({
      ...group,
      tables: group.elements.map((element) => {
        const gradeMap = new Map();
        const rowMap = new Map();

        (element?.rekapan || []).forEach((rekapan) => {
          const gradeId = String(
            rekapan?.ysb_grade_level_id ?? ""
          );

          if (!gradeMap.has(gradeId)) {
            gradeMap.set(gradeId, {
              id: rekapan?.ysb_grade_level_id,
              name: rekapan?.name_tingkatan || "-",
            });
          }

          (rekapan?.sub_elements || []).forEach((sub) => {
            const rowKey = String(
              sub?.ysb_sub_element_id ?? ""
            );

            if (!rowMap.has(rowKey)) {
              rowMap.set(rowKey, {
                key: rowKey,
                subElementId: sub?.ysb_sub_element_id,
                name: sub?.ysb_sub_element_name || "-",
              });
            }
          });
        });
        return {
          key: String(element?.id ?? ""),
          element,
          description: element?.description || "",
          grades: Array.from(gradeMap.values()),
          rows: Array.from(rowMap.values()),
        };
      }),
    }));
  }, [getData]);

  const fetchInit = useCallback(async () => {
    setLoading(true);

    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [
        branchRes,
        semesterRes,
        dimensiRes,
      ] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),

        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),

        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
      ]);

      if (!isMounted.current) return;

      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];

        setGetDataBranch(branches);

        if (branches.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_branch_id:
              prev.ysb_branch_id ||
              branches[0].branch_code,
          }));
        }
      }

      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];

        const active =
          semesters.find(
            (semester) =>
              Number(semester?.status) === 1
          ) || semesters[0];

        setGetDataSemesterMap(semesters);

        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");

          setForm2((prev) => ({
            ...prev,
            ysb_semester_id:
              prev.ysb_semester_id || active.id,
          }));
        }
      }

      if (dimensiRes?.status === 200) {
        const dims = (
          dimensiRes.data.data || []
        ).filter(
          (dimensi) =>
            Number(dimensi?.status) === 1
        );

        setGetDataDimensi(dims);

        if (dims.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_dimensi_id:
              prev.ysb_dimensi_id || dims[0].id,
          }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text:
          err?.response?.data?.message ||
          err.message ||
          "Error",
        icon: "error",
      });
    }
  }, [
    ascending,
    descending,
    fetchParams,
    keyword,
    limit,
    page,
    storageBranchGroping,
    storageLevel,
  ]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      setLoadingSchool(true);

      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let schools = res.data.data || [];

          if (
            storageLevel === "developer" ||
            storageLevel === "superadmin"
          ) {
            schools = schools.filter(
              (school) =>
                school?.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(
            schools,
            branchId
          );

          schools = sortSchools(schools);

          setGetDataSchool(schools);

          setForm2((prev) => ({
            ...prev,
            ysb_school_id:
              schools.length > 0
                ? schools[0].school_code
                : "",
          }));
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingSchool(false);
        setLoading(false);
      }
    },
    [
      ascending,
      fetchParams,
      limit,
      page,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) {
      fetchSchoolsByBranch(
        form2.ysb_branch_id
      );
    }
  }, [
    form2.ysb_branch_id,
    fetchSchoolsByBranch,
  ]);

  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_dimensi_id;

  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_dimensi_id
    ) {
      return;
    }

    const params = {
      ysb_semester_id: form2.ysb_semester_id,
      level: storageLevel,
      branch: form2.ysb_branch_id,
      ysb_dimensi_id: form2.ysb_dimensi_id,
      ysb_school_id: form2.ysb_school_id,
    };

    const qk = JSON.stringify(params);
    queryKeyRef.current = qk;

    try {
      const response = await APILA.get(
        "/api/dimensi-config-heads/show",
        {
          params,
          ...fetchParams,
        }
      );

      if (queryKeyRef.current !== qk) {
        return;
      }

      if (response?.status === 200) {
        const sorted = sortDimensiByTingkatan([
          ...(response.data.data || []),
        ]);

        setGetData(sorted);
        setSavingMap({});
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data",
        icon: "error",
      });
    }
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    fetchParams,
    storageLevel,
  ]);

  useEffect(() => {
    if (
      groupedElements.length > 0 &&
      !selectedTab
    ) {
      setSelectedTab(groupedElements[0].key);
    }
  }, [groupedElements, selectedTab]);

  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_dimensi_id
    ) {
      return;
    }

    firstLoadDone.current = true;

    const loadFirstData = async () => {
      setIsFetching(true);

      try {
        await GetResponseData();

        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
      } finally {
        setIsFetching(false);
      }
    };

    loadFirstData();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    GetResponseData,
  ]);

  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "ysb_branch_id"
        ? {
            ysb_school_id: "",
          }
        : {}),
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
      setSavingMap({});
    }
  };

  const handleCari = async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_dimensi_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text:
          "Pastikan Semester, Cabang, Sekolah, dan Dimensi sudah dipilih.",
        icon: "warning",
      });

      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();

      setHasSearched(true);
      setIsFilterDirty(false);
    } finally {
      setIsFetching(false);
    }
  };

  const idUser = (
    localStorage.getItem("id_admin") || ""
  ).replace(/[|&;$%@"<>()+,]/g, "");

  const extractReturnedId = (res) => {
    return (
      res?.data?.data?.ysb_dimensi_config_head_id ||
      res?.data?.data?.id ||
      res?.data?.ysb_dimensi_config_head_id ||
      res?.data?.id ||
      null
    );
  };

  const handleToggleSubElement = async (
    sub,
    rekapan,
    element,
    newState,
    cellId,
    qk
  ) => {
    const configId =
      sub?.ysb_dimensi_config_head_id ??
      sub?.ysb_dimensi_config_id ??
      "default";

    const endpoint =
      configId === "default"
        ? "/api/dimensi-config-heads/default"
        : `/api/dimensi-config-heads/${configId}`;

    const payload = {
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
      ysb_semester_id: form2.ysb_semester_id,
      ysb_grade_level_id:
        rekapan.ysb_grade_level_id,
      ysb_element_id: element.id,
      ysb_sub_element_id:
        sub.ysb_sub_element_id,
      state_form: newState,
      user_id: idUser,
    };

    try {
      setSavingMap((prev) => ({
        ...prev,
        [cellId]: true,
      }));

      const res = await APILA.put(
        endpoint,
        payload,
        fetchParams
      );

      if (queryKeyRef.current !== qk) {
        ToastSuccess.fire({
          icon: "success",
          title:
            res?.data?.message ||
            "Berhasil disimpan",
        });

        return;
      }

      if (res?.status === 200) {
        const returnedId =
          extractReturnedId(res);

        setGetData((prev) =>
          prev.map((dim) => ({
            ...dim,

            data_element: (
              dim?.data_element || []
            ).map((el) => ({
              ...el,

              rekapan: (
                el?.rekapan || []
              ).map((r) => ({
                ...r,

                sub_elements: (
                  r?.sub_elements || []
                ).map((s) => {
                  const match =
                    String(
                      s?.ysb_sub_element_id
                    ) ===
                      String(
                        sub?.ysb_sub_element_id
                      ) &&
                    String(
                      r?.ysb_grade_level_id
                    ) ===
                      String(
                        rekapan?.ysb_grade_level_id
                      ) &&
                    String(el?.id) ===
                      String(element?.id);

                  if (!match) return s;

                  return {
                    ...s,
                    form_state: newState,

                    ysb_dimensi_config_head_id:
                      returnedId ||
                      s?.ysb_dimensi_config_head_id,
                  };
                }),
              })),
            })),
          }))
        );

        ToastSuccess.fire({
          icon: "success",
          title:
            res?.data?.message ||
            "Berhasil disimpan",
        });
      }
    } catch (err) {
      ToastError.fire({
        icon: "error",
        title:
          err?.response?.data?.message ||
          err.message ||
          "Gagal menyimpan perubahan",
      });

      try {
        if (queryKeyRef.current === qk) {
          await GetResponseData();
        }
      } catch (_) {}
    } finally {
      setSavingMap((prev) => {
        const clone = {
          ...prev,
        };

        delete clone[cellId];

        return clone;
      });
    }
  };

  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body module-page assessment-page">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faGear} />
              </span>

              <h4 className="page-title-text">
                Konfigurasi Nilai
              </h4>
            </div>
          </div>

          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-main">
                  Beranda
                </Link>
              </li>

              <li className="custom-breadcrumb-separator">
                /
              </li>

              <li className="custom-breadcrumb-item">
                <Link to="/element-recaps-dimensi">
                  Penilaian
                </Link>
              </li>

              <li className="custom-breadcrumb-separator">
                /
              </li>

              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                Konfigurasi Nilai
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content module-content">
          {/* TAB MENU */}
          <div className="assessment-mode-tabs">
            <div>
              <button className="btn assessment-mode-tab">
                <Link to="/element-recaps-dimensi/dimensi-configs">
                  Konfigurasi Nilai Guru
                </Link>
              </button>
            </div>

            <div className="ml-2">
              <button
                className="btn assessment-mode-tab active"
                style={{
                  backgroundColor: "#076db5ff",
                  color: "#fff",
                }}
              >
                Konfigurasi Nilai Kepala Sekolah
              </button>
            </div>

            <div className="ml-2">
              <button className="btn assessment-mode-tab">
                <Link to="/element-recaps-dimensi/config-list-dimensi">
                  Konfigurasi Dimensi
                </Link>
              </button>
            </div>
          </div>

          <hr className="assessment-mode-divider" />

          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="assessment-filter-card assessment-filter-mobile">
              <Row>
                <select
                  className="assessment-filter-select"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    {namaTA
                      ? `${namaTA} (Semester ${namaSmstr})`
                      : "Pilih Semester"}
                  </option>

                  {getDataSemesterMap.map(
                    (semester, index) => (
                      <option
                        key={semester?.id || index}
                        value={semester?.id}
                      >
                        {semester?.name_year} (Semester{" "}
                        {semester?.semester})
                        {Number(semester?.status) === 1
                          ? " • Aktif"
                          : ""}
                      </option>
                    )
                  )}
                </select>
              </Row>

              <Row>
                <select
                  className="assessment-filter-select"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map(
                    (branch, index) => (
                      <option
                        key={
                          branch?.branch_code || index
                        }
                        value={branch?.branch_code}
                      >
                        {branch?.branch_name}
                      </option>
                    )
                  )}
                </select>
              </Row>

              <Row>
                <select
                  className="assessment-filter-select"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={loadingSchool}
                >
                  <option value="" hidden>
                    {loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map(
                      (school, index) => (
                        <option
                          key={
                            school?.school_code ||
                            index
                          }
                          value={school?.school_code}
                        >
                          {school?.school_name}
                        </option>
                      )
                    )}
                </select>
              </Row>

              <Row>
                <select
                  className="assessment-filter-select"
                  name="ysb_dimensi_id"
                  value={form2.ysb_dimensi_id}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    Pilih Dimensi
                  </option>

                  {getDataDimensi.map(
                    (dimensi, index) => (
                      <option
                        key={dimensi?.id || index}
                        value={dimensi?.id}
                      >
                        {dimensi?.name_dimensi}
                      </option>
                    )
                  )}
                </select>
              </Row>

              <Row>
                <button
                  className="btn assessment-filter-button"
                  onClick={handleCari}
                  disabled={
                    !isFilterComplete ||
                    isFetching
                  }
                >
                  {isFetching ? "Memuat..." : "Cari"}
                </button>
              </Row>
            </div>
          ) : (
            <div className="assessment-filter-card mb-3">
              {loading ? (
                <>
                  <div className="assessment-filter-row d-flex">
                    <div
                      className="shimmer shimmer-select mr-2"
                      style={{ width: 190 }}
                    />

                    <div
                      className="shimmer shimmer-select mr-2"
                      style={{ width: 210 }}
                    />

                    <div
                      className="shimmer shimmer-select mr-2"
                      style={{ width: 240 }}
                    />
                  </div>

                  <div className="assessment-filter-row mt-3 d-flex">
                    <div
                      className="shimmer shimmer-select mr-2"
                      style={{ width: 220 }}
                    />

                    <div
                      className="shimmer shimmer-select"
                      style={{ width: 80 }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="assessment-filter-row d-flex">
                    <select
                      className="assessment-filter-select mr-2"
                      name="ysb_semester_id"
                      value={form2.ysb_semester_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>
                        {namaTA
                          ? `${namaTA} (Semester ${namaSmstr})`
                          : "Pilih Semester"}
                      </option>

                      {getDataSemesterMap.map(
                        (semester, index) => (
                          <option
                            key={
                              semester?.id || index
                            }
                            value={semester?.id}
                          >
                            {semester?.name_year}{" "}
                            (Semester{" "}
                            {semester?.semester})
                            {Number(
                              semester?.status
                            ) === 1
                              ? " • Aktif"
                              : ""}
                          </option>
                        )
                      )}
                    </select>

                    <select
                      className="assessment-filter-select mr-2"
                      name="ysb_branch_id"
                      value={form2.ysb_branch_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>
                        Pilih Cabang
                      </option>

                      {getDataBranch.map(
                        (branch, index) => (
                          <option
                            key={
                              branch?.branch_code ||
                              index
                            }
                            value={
                              branch?.branch_code
                            }
                          >
                            {branch?.branch_name}
                          </option>
                        )
                      )}
                    </select>

                    <select
                      className="assessment-filter-select"
                      name="ysb_school_id"
                      value={form2.ysb_school_id}
                      onChange={handleChange}
                      disabled={loadingSchool}
                    >
                      <option value="" hidden>
                        {loadingSchool
                          ? "Memuat data sekolah..."
                          : "Pilih Sekolah"}
                      </option>

                      {!loadingSchool &&
                        getDataSchool.map(
                          (school, index) => (
                            <option
                              key={
                                school?.school_code ||
                                index
                              }
                              value={
                                school?.school_code
                              }
                            >
                              {school?.school_name}
                            </option>
                          )
                        )}
                    </select>
                  </div>

                  <div className="assessment-filter-row mt-3 d-flex">
                    <select
                      className="assessment-filter-select mr-2"
                      name="ysb_dimensi_id"
                      value={form2.ysb_dimensi_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>
                        Pilih Dimensi
                      </option>

                      {getDataDimensi.map(
                        (dimensi, index) => (
                          <option
                            key={dimensi?.id || index}
                            value={dimensi?.id}
                          >
                            {dimensi?.name_dimensi}
                          </option>
                        )
                      )}
                    </select>

                    <button
                      className="btn assessment-filter-button"
                      onClick={handleCari}
                      disabled={
                        !isFilterComplete ||
                        isFetching
                      }
                    >
                      {isFetching
                        ? "Memuat..."
                        : "Cari"}
                    </button>
                  </div>
                </>
              )}
            </div>
          )}

          {/* LOADER */}
          {isFetching && (
            <div
              className="text-center"
              style={{ padding: "10px 0" }}
            >
              <PulseLoader
                color="#4368c5"
                size={12}
              />
            </div>
          )}

          {/* DATA KOSONG */}
          {hasSearched &&
            !isFetching &&
            getData.length === 0 && (
              <div className="module-table-card">
                <div className="module-empty-state-content">
                  Data konfigurasi belum tersedia untuk
                  filter yang dipilih.
                </div>
              </div>
            )}

          {/* TABS */}
          {hasSearched &&
            !isFetching &&
            getData.length > 0 && (
              <Tabs
                activeKey={selectedTab}
                onSelect={(key) =>
                  setSelectedTab(key)
                }
                className="assessment-tabs mb-3 mt-4 nav-tabs"
              >
                {groupedElements.map((group, idx) => (
                  <Tab
                    key={group?.key || idx}
                    eventKey={group?.key}
                    title={group?.name}
                  >
                    {(group?.tables || []).map(
                      (table, tableIndex) => (
                        <React.Fragment
                          key={
                            table?.key || tableIndex
                          }
                        >
                    <div className="assessment-element-info">
                      <h5 className="mt-2 mb-2">
                        {table?.description}
                      </h5>
                    </div>

                    <Col
                      xl="12"
                      sm="12"
                      className="module-column mb-4"
                    >
                      <div className="mt-3">
                        <div className="module-table-card">
                          <div className="module-table-scroll config-matrix-scroll">
                            <table className="module-table config-matrix-table">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      width: "40%",
                                    }}
                                  >
                                    Indikator
                                  </th>

                                  {table?.grades?.map(
                                    (grade, index) => (
                                      <th
                                        key={
                                          grade?.id ||
                                          index
                                        }
                                      >
                                        {grade?.name}
                                      </th>
                                    )
                                  )}
                                </tr>
                              </thead>

                              <tbody>
                                {(table?.rows || []).map(
                                  (row, rowIndex) => (
                                    <tr
                                      key={
                                        row?.key ||
                                        rowIndex
                                      }
                                    >
                                      <td
                                        style={{
                                          textAlign: "left",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {row?.name}
                                      </td>

                                      {(table?.grades || []).map(
                                        (grade, gradeIndex) => {
                                          const element = table?.element;
                                          const rekapan = (
                                            element?.rekapan || []
                                          ).find(
                                            (item) =>
                                              String(
                                                item?.ysb_grade_level_id
                                              ) === String(grade?.id)
                                          );
                                          const sub = (
                                            rekapan?.sub_elements || []
                                          ).find(
                                            (item) =>
                                              String(
                                                item?.ysb_sub_element_id
                                              ) ===
                                              String(row?.subElementId)
                                          );

                                          if (!rekapan || !sub) {
                                            return (
                                              <td
                                                key={`${row?.key}|${grade?.id || gradeIndex}`}
                                              >
                                                -
                                              </td>
                                            );
                                          }

                                          const cellId = `${filterKey}|${element?.id}|${rekapan?.ysb_grade_level_id}|${sub?.ysb_sub_element_id}`;

                                          const currentValue =
                                            Number(
                                              sub?.form_state
                                            ) || 0;

                                          const qk =
                                            queryKeyRef.current;

                                          return (
                                            <td
                                              key={`${row?.key}|${grade?.id || gradeIndex}`}
                                            >
                                              <div className="config-matrix-toggle-wrap">
                                                {savingMap[
                                                  cellId
                                                ] ? (
                                                  <ClipLoader
                                                    size={16}
                                                    color="#4368c5"
                                                  />
                                                ) : (
                                                  <div className="form-check form-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input config-dimension-switch"
                                                      checked={
                                                        currentValue ===
                                                        1
                                                      }
                                                      disabled={
                                                        !permission.update &&
                                                        storageLevel !==
                                                          "developer" &&
                                                        storageLevel !==
                                                          "superadmin"
                                                      }
                                                      onChange={(
                                                        e
                                                      ) => {
                                                        if (
                                                          savingMap[
                                                            cellId
                                                          ]
                                                        ) {
                                                          return;
                                                        }

                                                        const newState =
                                                          e
                                                            .target
                                                            .checked
                                                            ? 1
                                                            : 0;

                                                        handleToggleSubElement(
                                                          sub,
                                                          rekapan,
                                                          element,
                                                          newState,
                                                          cellId,
                                                          qk
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                          );
                                        }
                                      )}
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>
                        </React.Fragment>
                      )
                    )}
                  </Tab>
                ))}
              </Tabs>
            )}
        </div>
      </div>
    </>
  );
}
